import * as GlobalService from "../global_services";
var isFirstTimeOpen = true;
var keyName = "BetaInventory";
var metaDataOrderObject = {
  BetaInventory: {
    ManageInventory: {
      filterData: {},
      gridConfig: {},
      collapseData: {},
      sorableSection: "",
      saveFilter: [],
    }
  }
};

// call api for get metaData of order is it's open first time
export const getUserClientMetaData = function() {
  if (isFirstTimeOpen) {
    return GlobalService.getUserClientMetaData(keyName).then(
      function successCallBack(response) {
        if (response != "") {
          Object.assign(metaDataOrderObject[keyName], JSON.parse(response));
        }
        console.log("response  metaDataOrderObject :", metaDataOrderObject);
        isFirstTimeOpen = false;
        return true;
      },
      function errorCallBack(response) {
        console.log(response);
        return false;
      }
    );
  }
};

export const clearInventoryFilterMetaData = function(objName) {
  metaDataOrderObject[keyName]["ManageInventory"]["filterData"] = {};
  GlobalService.setUserClientMetaData(
    keyName,
    JSON.stringify(metaDataOrderObject[keyName])
  );
};

export const setInventoryFilterMetaData = function (filterData) {
    metaDataOrderObject[keyName]['ManageInventory']['filterData'] = filterData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
}
export const getInventoryFilterMetaData = function () {
    if (!$.isEmptyObject(metaDataOrderObject[keyName]['ManageInventory']['filterData'])) {
        return metaDataOrderObject[keyName]['ManageInventory']['filterData'];
    } else {
        return "";
    }

}

export const setManageInventoryGridOptionInMetaData = function(
  gridConfig
) {
  metaDataOrderObject[keyName]["ManageInventory"]["gridConfig"] =
    gridConfig.optionsData;
  GlobalService.setUserClientMetaData(
    keyName,
    JSON.stringify(metaDataOrderObject[keyName])
  );
};
export const applySavedFilterDataToInventoryGrid = function (gridConfig, filterData) {
  metaDataOrderObject[keyName]['ManageInventory']['gridConfig'] = gridConfig.optionsData;
  metaDataOrderObject[keyName]['ManageInventory']['filterData'] = filterData;

  GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
}
export const getManageInventoryGridOptionInMetaData = function() {
  if (
    !$.isEmptyObject(
      metaDataOrderObject[keyName]["ManageInventory"]["gridConfig"]
    )
  ) {
    return metaDataOrderObject[keyName]["ManageInventory"]["gridConfig"];
  } else {
    return "";
  }
};

export const setManageInventoryCollapseMetaData = function (collapseId, value) {
  if (!metaDataOrderObject[keyName]['ManageInventory']['collapseData']) {
      metaDataOrderObject[keyName]['ManageInventory']['collapseData'] = {}
  }
  metaDataOrderObject[keyName]['ManageInventory']['collapseData'][collapseId] = value;
  GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
}
export const getManageInventoryCollapseMetaData = function () {
  return metaDataOrderObject[keyName]['ManageInventory']['collapseData'];
}

export const setManageInventorySortSectionMetaData = function (sortArray) {
  metaDataOrderObject[keyName]['ManageInventory']['sorableSection'] = sortArray;
  GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
}
export const getManageInventorySortSectionMetaData = function () {
  return metaDataOrderObject[keyName]['ManageInventory']['sorableSection'];
}

// save filter of find order in meta data
export const saveManageInventoryFilterMetaData = function (title, filterObj, columnObj) {
  var setData = {
      title: title,
      filterData: filterObj,
      columnData: columnObj.optionsData
  };

  if (typeof metaDataOrderObject[keyName]['ManageInventory']['saveFilter'] == "undefined") {
      metaDataOrderObject[keyName]['ManageInventory']['saveFilter'] = [];
  }
  (metaDataOrderObject[keyName]['ManageInventory']['saveFilter']).push(setData);
  GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));

}
export const updateManageInventoryFilterMetaData = function (index, filterObj, columnObj) {

  if (typeof metaDataOrderObject[keyName]['ManageInventory']['saveFilter'][index] != "undefined") {
      metaDataOrderObject[keyName]['ManageInventory']['saveFilter'][index].filterData = filterObj;
      metaDataOrderObject[keyName]['ManageInventory']['saveFilter'][index].columnData = columnObj.optionsData;
      GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
  }

}
export const getSaveManageInventoryFilterListMetaData = function () {
  if (metaDataOrderObject[keyName]['ManageInventory']['saveFilter']) {
    return metaDataOrderObject[keyName]['ManageInventory']['saveFilter'];
  }

  return [];
}

export const clearSaveManageInventoryFilterListMetaData = function (index) {
  metaDataOrderObject[keyName]['ManageInventory']['saveFilter'].splice(index, 1);
  GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataOrderObject[keyName]));
}